module.exports = __webpack_public_path__ + "static/media/homes5.aa4896a2.png";